
import { Options, Vue } from "vue-class-component"; //基本需要
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  readPerformanceSelectOptions,
  readReportList,
  readPerformanceVersion,
} from "@/store/performance/getters";
import { store } from "@/store";
import {
  dispatchAccessUrl,
  dispatchCreateReport,
  dispatchDeleteReport,
  dispatchGetPerformanceSelectOptions,
  dispatchGetReportList,
  dispatchUpdateReport,
  dispatchGetPerformanceVersion,
} from "@/store/performance/actions";
import { dateConversion, getLocalProject, unique_json } from "@/utils";
import { IReport } from "@/interfaces";
import { ElMessage } from "element-plus";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";
import { dispatchGetProjectDetail } from "@/store/project/actions";
import { readUserProfile } from "@/store/main/getters";

// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class ReportList extends Vue {
  // 声明属性
  public localProject = Number(getLocalProject()); //得到该的项目的id
  public loading = false; //加载
  public dialogFormVisible = false; // 生成报告的弹窗是否可见
  public generateReportVersion = {
    // 弹窗内——生成报告的新/旧版本
    oldEdition: "",
    newEdition: "",
    scenetion: [],
  };
  public status_search: string | "" = ""; //风险等级
  public status_options = [
    {
      label: "高风险",
      value: "高风险",
    },
    {
      label: "低风险",
      value: "低风险",
    },
  ];

  public name_search = ""; //任务名称
  public report_creator = ""; //报告创建人
  public report_old_version: any | "" = ""; //过滤老版本
  public report_new_version: any | "" = ""; //过滤新版本
  public report_name_placeholder = "【GR自动化性能】项目名-新版本号"; //弹窗内默认项目名称
  public search = ""; //搜索的内容
  public currentPage1 = 1; //当前页
  public record = 16; //记录条数

  // 页面初始化
  public async mounted() {
    this.loading = true;
    await this.get_project_name;
    dispatchGetPerformanceSelectOptions(store, {
      project: this.localProject,
    });
    await dispatchGetReportList(store, {
      project: this.localProject,
      page: 1,
      size: this.record,
      report_name: this.name_search,
      new_version: this.report_new_version,
      old_version: this.report_old_version,
      risk: this.status_search,
      creator: this.report_creator,
    });
    await dispatchGetProjectDetail(store, {
      id: this.localProject,
      project: this.localProject,
    });
    this.loading = false;
  }

  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 打开生成报告
  public generateReportsManually() {
    this.dialogFormVisible = true;
    this.generateReportVersion.oldEdition = "";
    this.generateReportVersion.newEdition = "";
    this.report_name_placeholder = "【GR自动化性能】项目名-新版本号";
  }
  // 发送邮件
  public saveEmail(row: IReport) {
    dispatchAccessUrl(store, { project: this.localProject, report_id: row.id });
    ElMessage({
      message: "报告正在发送",
      showClose: true,
    });
  }
  //获取下拉选择选项
  public get getPerformanceSelectOptions() {
    return readPerformanceSelectOptions(store);
  }
  // 弹窗、表格 —— 游戏版本选择列表
  public get game_version_options() {
    const versions = this.getPerformanceSelectOptions.game_versions; //获取性能选择选项里的有些版本
    const game_version_select: any[] = [];
    versions.forEach((item) => {
      if (item) {
        game_version_select.push({
          label: item,
          value: item,
        });
      } else {
        game_version_select.push({
          label: "空版本",
          value: "null_version",
        });
      }
    });
    return game_version_select;
  }

  // 获取项目列表
  public get report_list() {
    let report_list = readReportList(store);
    report_list.results.forEach((report) => {
      report.create_date = dateConversion(report.create_date);
    });
    return report_list;
  }
  public game_scene_version = [];
  public get getDateVersionsList() {
    return readPerformanceVersion(store);
  }
  public async selectVersion() {
    await dispatchGetPerformanceVersion(store, {
      project: this.localProject,
      version: (this.generateReportVersion.newEdition as any).split("|")[0],
      timestamp:
        (this.generateReportVersion.newEdition as any).split("|")[1] || "",
    });
    this.game_scene_version = this.getDateVersionsList.scene_list;
  }
  // 生成报告
  public async generateReport() {
    if (
      this.generateReportVersion.oldEdition === "" ||
      this.generateReportVersion.newEdition === ""
    ) {
      alert("版本号不能为空哦！");
      return;
    }
    if (
      this.generateReportVersion.oldEdition ===
      this.generateReportVersion.newEdition
    ) {
      alert("版本号不能相同哦！");
      return;
    }
    if (
      this.generateReportVersion.oldEdition >
      this.generateReportVersion.newEdition
    ) {
      alert("新版本号不能小于旧版本！");
      return;
    }
    this.loading = true;
    this.dialogFormVisible = false;
    await dispatchCreateReport(store, {
      //调用创建报告的接口，将所需数据传递过去
      project: this.localProject,
      new_version: this.generateReportVersion.newEdition.split("|")[0],
      old_version: this.generateReportVersion.oldEdition.split("|")[0],
      timestamp: this.generateReportVersion.newEdition.split("|")[1],
      old_timestamp: this.generateReportVersion.oldEdition.split("|")[1], // 老版本截止日期
      // report_name: this.report_name_placeholder,
      scene_list: this.generateReportVersion.scenetion,
    });
    await dispatchGetReportList(store, {
      project: this.localProject,
      page: 1,
      size: this.record,
      report_name: this.name_search,
      new_version: this.report_new_version,
      old_version: this.report_old_version,
      risk: this.status_search,
      creator: this.report_creator,
    });
    this.loading = false;
    this.dialogFormVisible = false;
  }

  // 激活报告名称
  // public activation() {
  //   this.report_name_placeholder =
  //     "【GR自动化性能】" +
  //     this.get_project_name +
  //     " -" +
  //     this.generateReportVersion.newEdition.split("|")[0];
  // }

  // 得到项目名称
  public get get_project_name() {
    const project_name = readProjectDetail(store).project_name;
    return project_name;
  }

  // 查看
  public handleEdit(index: number, row: any) {
    const { href } = this.$router.resolve({
      path:
        readProjectDetail(store).project_name === "AOV" ||
        readProjectDetail(store).project_name === "AOV测试项目"
          ? "/test_report_aov"
          : "/test_report",
      query: {
        report_id: row.id,
        project: row.project,
      },
    });
    window.open(href, "_blank");
    return Promise.resolve(false); // 不刷新表格
  }
  // 删除
  public async handleDelete(index: number, row: any) {
    this.loading = true;
    await dispatchDeleteReport(store, {
      project: this.localProject,
      report_id: row.id,
      page: 1,
      size: this.record,
      report_name: this.name_search,
      new_version: this.report_new_version,
      old_version: this.report_old_version,
      risk: this.status_search,
      creator: this.report_creator,
    });
    this.loading = false;
  }

  // 查询/分页
  public async onSearch(operation: any) {
    this.loading = true;
    await dispatchGetReportList(store, {
      project: this.localProject,
      page: operation === "Search" ? 1 : this.currentPage1,
      size: this.record,
      report_name: this.name_search,
      new_version: this.report_new_version,
      old_version: this.report_old_version,
      risk: this.status_search,
      creator: this.report_creator,
    });
    this.loading = false;
  }
  // 表格清空
  public async onClear() {
    this.loading = true;
    this.name_search = "";
    this.status_search = "";
    this.report_creator = "";
    this.report_new_version = "";
    this.report_old_version = "";
    this.currentPage1 = 1;
    await dispatchGetReportList(store, {
      project: this.localProject,
      page: this.currentPage1,
      size: this.record,
      report_name: this.name_search,
      new_version: this.report_new_version,
      old_version: this.report_old_version,
      risk: this.status_search,
      creator: this.report_creator,
    });
    this.loading = false;
  }

  // 列表清空
  public async handleClearAll(Version: any) {
    if (Version === "new") {
      this.report_new_version = "";
    } else {
      this.report_old_version = "";
    }
  }
  // 列表全选
  public async handleSelectAll(Version: any) {
    if (Version === "new") {
      this.report_new_version =
        this.filterVersion("new").map((item: any) => item.value) || [];
    } else {
      this.report_old_version =
        this.filterVersion("old").map((item: any) => item.value) || [];
    }
  }

  // 风险等级查询
  public filterHandler(value: any, row: any, column: any) {
    const property = column["columnKey"];
    return row[property] === value;
  }

  // 版本数据
  public filterVersion(Version: any) {
    const filterVersion: any[] = [];
    this.report_list.results.forEach((item) => {
      filterVersion.push({
        text: Version === "old" ? item.old_version : item.new_version,
        value: Version === "old" ? item.old_version : item.new_version,
      });
    });
    return unique_json(filterVersion, "value");
  }

  //更新报告
  public async getReportName(row: any) {
    this.loading = true;
    await dispatchUpdateReport(store, {
      id: row.id,
      report_name: row.report_name,
      new_version: row.new_version,
      old_version: row.old_version,
      test_info: row.test_info,
      risk: row.risk,
      create_date: row.create_date,
      settings: row.settings,
      creator: row.creator,
      project: row.project,
    });
    this.loading = false;
  }
}
